import React, { Component } from 'react'
import RoleControlled from '../../_common/RoleControlled'
import { deleteMsg } from '../../../const'

class FaqItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: false,
      defaultQuestion: this.props.faq.question,
      defaultAnswer: this.props.faq.answer,
      question: this.props.faq.question,
      answer: this.props.faq.answer
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { faq } = this.props
    const { edit, question, answer } = this.state
    if (
      faq.answer !== nextProps.faq.answer ||
      faq.question !== nextProps.faq.question ||
      edit !== nextState.edit ||
      question !== nextState.question ||
      answer !== nextState.answer
    ) {
      return true
    } else {
      return false
    }
  }

  _handleEditClick () {
    this.setState({ edit: true })
  }
  _handleDeleteClick () {
    // console.log('delete faq id: ', this.props.faq.qa_id)
    const res = window.confirm(deleteMsg)
    if (res) {
      this.props.deleteData(this.props.faq.qa_id)
    }
  }
  _handleCancelClick () {
    this.setState({
      edit: false,
      question: this.state.defaultQuestion,
      answer: this.state.defaultAnswer
    })
  }
  _handleSaveClick () {
    // console.log('saving data...')
    const { question, answer } = this.state
    const data = {
      qa_id: this.props.faq.qa_id,
      question,
      answer
    }
    this.props.saveData(data)
    this.setState({ edit: false })
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _renderFaqQuestion () {
    if (this.state.edit) {
      return <textarea rows="1" type="text" value={this.state.question} onChange={this._handleUpdateContent.bind(this, 'question')}></textarea>
    }
    return (
      <div className="faq_value">{this.state.question}</div>
    )
  }
  _renderFaqAnswer () {
    if (this.state.edit) {
      return <textarea rows="1" type="text" value={this.state.answer} onChange={this._handleUpdateContent.bind(this, 'answer')}></textarea>
    }
    return (
      <div className="faq_value">{this.state.answer}</div>
    )
  }

  _renderBtns () {
    if (this.state.edit) {
      return [
        <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>,
        <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
      ]
    }
    return [
      <button key="delete" className="btn red" onClick={this._handleDeleteClick.bind(this)}>削除</button>,
      <button key="edit" className="btn reverse_primary" onClick={this._handleEditClick.bind(this)}>編集</button>
    ]
  }

  render () {
    return (
      <article className="faq">
        <div className="faq_inner flex column">
          <div className="contents flex question">
            <div className="faq_label">Q</div>
            { this._renderFaqQuestion()}
          </div>
          <div className="contents flex answer">
            <div className="faq_label">A</div>
            { this._renderFaqAnswer()}
          </div>
        </div>
        <RoleControlled role={this.props.role} acceptedRoles={[0, 1]}>
          <div className="btn_group flex">
            { this._renderBtns() }
          </div>
        </RoleControlled>
      </article>
    )
  }
}

export default FaqItem



// WEBPACK FOOTER //
// ./src/components/Properties/Faq/FaqItem.js